<div class="jhmi-secure-documents jhm-page" [class.mobile]="screenSize==='MOBILE'">
	<div class="jhm-top-toolbar">
	  <div class="left">
		<div class="title-item">
		  <div class="fa-solid fa-bars nav-open" (click)="openNav()"></div>
		  <div class="title">
			Secure Documents
		  </div>
		</div>
	  </div>
	  <div class="right">
		<button class="action jhm-button primary" (click)="onNewDocumentClicked()"><i class="fa-solid fa-plus"></i>New Document</button>
	  </div>
	</div>
	<jhm-table
	  [repository]="inmateSecureDocumentCountRepository"
	  [zeroState]="'documents'">
	</jhm-table>
</div>